import CompanyProfileComponent from "../components/CompanyProfile";
import useCompanyProfile from "../hooks/useCompanyProfile";

const CompanyProfile = () => {
  const companyProfileProps = useCompanyProfile();
  return <CompanyProfileComponent {...companyProfileProps} />;
};

export default CompanyProfile;
